var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"green","indeterminate":""}}):_c('div',[_c('List',{attrs:{"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }